import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MomentModule } from 'ngx-moment';

import { PadNumberPipe } from '../../pipes/pad-number.pipe';
import { CalendarComponent } from './calendar/calendar.component';
import { DatepickerComponent } from './datepicker.component';

@NgModule({
  imports: [CommonModule, FormsModule, MomentModule],
  declarations: [DatepickerComponent, CalendarComponent, PadNumberPipe],
  exports: [DatepickerComponent, CalendarComponent]
})
export class DatepickerModule {}
